import { render, staticRenderFns } from "./CsdsPage.vue?vue&type=template&id=beb45aea&scoped=true&"
import script from "./CsdsPage.vue?vue&type=script&lang=js&"
export * from "./CsdsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb45aea",
  null
  
)

export default component.exports